var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSimpleAcc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#F4FAF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 28H25M31 24H25M21 35.646V25.054C21 22.2 21 20.774 21.879 19.887C22.757 19 24.172 19 27 19H31C33.828 19 35.243 19 36.121 19.887C37 20.773 37 22.2 37 25.054V35.646C37 37.157 37 37.913 36.538 38.211C35.783 38.697 34.616 37.677 34.029 37.307C33.544 37.001 33.302 36.849 33.032 36.84C32.742 36.83 32.495 36.977 31.971 37.307L30.06 38.512C29.544 38.837 29.287 39 29 39C28.713 39 28.456 38.837 27.94 38.512L26.03 37.307C25.544 37.001 25.302 36.849 25.033 36.84C24.742 36.83 24.495 36.977 23.971 37.307C23.384 37.677 22.217 38.697 21.461 38.211C21 37.913 21 37.158 21 35.646Z",
    stroke: "#4A3AFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimpleAcc);
export default __webpack_public_path__ + "static/media/simpleAcc.948f9713258835b1760e3cc31267761a.svg";
export { ForwardRef as ReactComponent };